import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Missive Case Study | Canny';
const Description =
  'Read about how Missive uses Canny to cut down on support time and prioritize new features.';
const Image = 'https://canny.io/images/62108ff1159b342843c2c29f459776ac.jpg';
const MissiveUrl = 'https://canny.io/case-studies/missive';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${MissiveUrl}#webpage`,
    url: MissiveUrl,
    name: 'Case Study: Missive × Canny',
    description: 'How Missive uses Canny to cut down on support time and prioritize new features.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${MissiveUrl}#article`,
    genre: 'Case Study',
    headline: 'How Missive uses Canny to cut down on support time and prioritize new features',
    description:
      'Missive replaced spreadsheets with Canny, creating a central hub for feature requests. The team now uses feedback boards, MRR-based sorting, and internal comments to prioritize high-impact features—reducing support time and making decision-making easier.',
    inLanguage: 'en',
    url: MissiveUrl,
    mainEntityOfPage: { '@id': `${MissiveUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Missive', url: 'https://missiveapp.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Missive', item: MissiveUrl },
  ]),
]);

export default class MissiveLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },
          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: MissiveUrl },
          { property: 'og:type', content: 'website' },
          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
